import { t } from "@lingui/core/macro";
import { useState } from "react";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { SquareCardEntryModal } from "../../../../../features/Square/SquareCardEntryModal/SquareCardEntryModal";
import { useCreateUserCardOnFile } from "../../../../../features/Square/SquareCardEntryModal/hooks/useCreateUserCardOnFile";

export const SquareCardEntryModalWrapper = ({
  isOpen,
  setIsOpen,
  onReturnToPaymentMethods,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onReturnToPaymentMethods: (message?: string) => void;
}) => {
  const [createSquareCard, isCreatingSquareCard] = useCreateUserCardOnFile();
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const returnToList = (message?: string) => {
    setIsOpen(false);
    onReturnToPaymentMethods(message);
  };

  return isOpen ? (
    <SquareCardEntryModal
      isOpen
      onCardEntryCancel={() => returnToList()}
      onCardEntryError={returnToList}
      onCardEntryComplete={(card) =>
        createSquareCard({ squareNonce: card.nonce })
      }
      onCardEntrySaved={() => {
        returnToList();
        showToast({ description: t`Card added`, semanticStyle: "success" });
      }}
      loading={loading || isCreatingSquareCard}
      setLoading={setLoading}
    />
  ) : null;
};
